import type { ImportTypeKey, ImportUploadResult } from '@/types/import';

/**
 * Demo-mode upload response. The page follows the upload by looking the session up in the list, so
 * the fabricated result mirrors what the API returns for a freshly queued workbook.
 *
 * The confirm / cancel / download demo callbacks are no-ops and stay inline in the hook.
 */
export async function uploadImportDemoFn({ importType }: { importType: ImportTypeKey }): Promise<ImportUploadResult> {
  return { publicId: crypto.randomUUID(), importType, status: 'Uploaded' };
}
